import { useParams, Link } from "react-router-dom";
import { POLICIES } from "../lib/data";

export default function Policy() {
  const { slug } = useParams();
  const policy = POLICIES[slug];

  if (!policy) {
    return (
      <div className="mx-auto max-w-3xl px-5 pb-24 pt-40">
        <h1 className="font-display text-5xl">PAGE NOT FOUND</h1>
        <Link to="/" className="mt-6 inline-block font-tech text-xs tracking-[0.2em] text-ll-red">BACK HOME</Link>
      </div>
    );
  }

  return (
    <div data-testid={`policy-page-${slug}`} className="mx-auto max-w-3xl px-5 pb-24 pt-32 md:pt-40">
      <p className="font-tech text-[11px] tracking-[0.3em] text-ll-red">ETERNEL</p>
      <h1 className="mt-2 font-display text-6xl tracking-wide">{policy.title}</h1>
      <p data-testid="policy-review-notice" className="mt-6 border border-ll-red/40 bg-ll-red/10 px-4 py-3 font-tech text-[11px] leading-relaxed tracking-wide text-ll-bone/90">
        DRAFT FOR OWNER REVIEW — This starter content must be reviewed and approved by the store owner (and qualified counsel where needed) before publishing. It is not legal advice.
      </p>
      <div className="mt-10 space-y-6">
        {policy.body.map((p, i) => (
          <p key={i} className="text-sm leading-relaxed text-ll-steel">{p}</p>
        ))}
      </div>
    </div>
  );
}
